namespace Areas.Analysis.WeatherChart{
    "use strict";

    var weatherChartTabItems = Areas.createTabsWithSameController("Analysis",
        ["Monthly", "Daily", "Hourly"], "WeatherChart");

    export function weatherChartTabInitialized(params: any) {
        return Areas.tabInitialized(weatherChartTabItems)(params);
    }

}